<div class="modal-content">
    <div class="modal-header">

        <h3 class="text-center title justify-content-center m-0 w-100">{{'languages.affaire.addAffaire' | translate}}</h3>
        <ng-container *ngIf="show_loading_add">
            <div>
                <div class="col-12 text-center">
                    <div  class="customWidth">
                        <mat-spinner [diameter]="20"></mat-spinner>
                    </div>
                </div>
            </div>
        </ng-container>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">

        <div class="row">
            <div class="col-md-6 mt-3">
                <div class="form-group">
                    <mat-form-field class="example-full-width w-100">
                        <mat-label>  {{'languages.affaire.idOpp' | translate}}</mat-label>

                        <input matInput placeholder="Id Opportunités" [(ngModel)]="Id_opp" name="nom" required>
                    </mat-form-field>

                </div>
            </div>
            <div class="col-md-6 d-flex justify-content-center mt-1">
                <mat-spinner *ngIf="listAffect.length==0" [diameter]="20"></mat-spinner>
                <mat-form-field *ngIf="listAffect.length!=0" class="full-width" appearance="standard">
                    <mat-label>  {{'languages.ticket.Commercial' | translate}}</mat-label>

                    <input type="text" required matInput [formControl]="affecterAFormControl" [matAutocomplete]="auto">
                    <mat-autocomplete autoActiveFirstOption [displayWith]="displayContactFn" #auto="matAutocomplete">
                        <mat-option *ngFor="let option of listCommerciauxFilter | async" [value]="option">
                            {{option.nom + ' ' + option.prenom}}
                        </mat-option>
                    </mat-autocomplete>

                    <mat-error
                        *ngIf="affecterAFormControl.invalid && (affecterAFormControl.dirty || affecterAFormControl.touched) "
                        class="message-erreur">
                        <div *ngIf="affecterAFormControl.hasError('required')">
<i class="fa-solid fa-triangle-exclamation"></i>
                             {{'languages.affaire.commercialOblig' | translate}}
                        </div>
                    </mat-error>

                    <mat-error class="message-erreur"
                        *ngIf="affecterAFormControl.hasError('invalidAutocompleteObject') &&  !affecterAFormControl.hasError('required')">
<i class="fa-solid fa-triangle-exclamation"></i> {{'languages.affaire.verifyCommecial' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-spinner *ngIf="listLigneProd.length==0" [diameter]="20"></mat-spinner>
                <mat-form-field *ngIf="listLigneProd.length!=0" class="full-width" appearance="standard">
                    <mat-label> {{'languages.gamme.lignePoduit' | translate}}</mat-label>
                    <input type="text" required matInput [formControl]="affecterLigneAFormControl" name="type"
                        [matAutocomplete]="autoLigne">
                    <mat-autocomplete (optionSelected)="selectContrat($event.option.value)" autoActiveFirstOption
                        [displayWith]="displayLingeFn" #autoLigne="matAutocomplete">
                        <mat-option *ngFor="let option of listLignedePorduitFilter | async" [value]="option">
                            {{option.type}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error
                        *ngIf="affecterLigneAFormControl.invalid && (affecterLigneAFormControl.dirty || affecterLigneAFormControl.touched) "
                        class="message-erreur">
                        <div *ngIf="affecterLigneAFormControl.hasError('required')">
<i class="fa-solid fa-triangle-exclamation"></i>
                             {{'languages.gamme.ligneProduitOblig' | translate}}
                        </div>
                    </mat-error>

                    <mat-error class="message-erreur"
                        *ngIf="affecterLigneAFormControl.hasError('invalidAutocompleteObject') &&  !affecterLigneAFormControl.hasError('required')">
<i class="fa-solid fa-triangle-exclamation"></i>  {{'languages.gamme.verifyLigneProduit' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-6">
                <div class="form-group">

                    <mat-spinner *ngIf="Compagnie.length==0" [diameter]="20"></mat-spinner>
                    <mat-form-field *ngIf="Compagnie.length!=0" class="full-width" appearance="standard">
                        <mat-label> {{'languages.listing.Compagnie' | translate}}</mat-label>
                        <input type="text" required matInput [formControl]="affecterACompagnie" name="compagnie"
                            [matAutocomplete]="autoCompagnie">
                        <mat-autocomplete (optionSelected)="selectCompagnie($event.option.value)"
                            [displayWith]="displayCompagnieFn" autoActiveFirstOption #autoCompagnie="matAutocomplete">
                            <mat-option *ngFor="let option of listCompagnieFilter | async" [value]="option">
                                {{option.denomination}}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error
                            *ngIf="affecterACompagnie.invalid && (affecterACompagnie.dirty || affecterACompagnie.touched) "
                            class="message-erreur">
                            <div *ngIf="affecterACompagnie.hasError('required')">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                 {{'languages.gamme.compagnieOblig' | translate}}
                            </div>
                        </mat-error>

                        <mat-error class="message-erreur"
                            *ngIf="affecterACompagnie.hasError('invalidAutocompleteObject') &&  !affecterACompagnie.hasError('required')">
                            <i class="fa-solid fa-triangle-exclamation"></i>  {{'languages.gamme.verifyCompagnie' | translate}}
                        </mat-error>
                    </mat-form-field>

                </div>
            </div>
            <div class="col-md-6">

                <ng-container *ngIf="show_loading_gamme">
                    <div>
                        <div class="col-12 text-center">
                            <div class="customWidth">
                                <mat-spinner [diameter]="20"></mat-spinner>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="!show_loading_gamme" class="form-group">


                    <mat-form-field class="full-width" appearance="standard">

                        <mat-label> {{'languages.affaire.label_gamme' | translate}}</mat-label>
                        <input type="text" [readonly]="!disabledlist" required matInput [formControl]="affecterAGamme"
                            name="gamme" [matAutocomplete]="autoGamme">

                        <mat-autocomplete (optionSelected)="selectGamme($event.option.value)"
                            [displayWith]="displayGammeFn" autoActiveFirstOption #autoGamme="matAutocomplete">
                            <mat-option *ngFor="let option of listGammeFilter | async" [value]="option">
                                {{option.libelle}}
                            </mat-option>
                        </mat-autocomplete>

                        <mat-error *ngIf="affecterAGamme.invalid && (affecterAGamme.dirty || affecterAGamme.touched)"
                            class="message-erreur">
                            <div *ngIf="affecterAGamme.hasError('required')&& gammeAppear">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                 {{'languages.gamme.obligGamme' | translate}}
                            </div>
                            <div *ngIf="!gammeAppear">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                 {{'languages.affaire.noGammeForCompagnie' | translate}}
                            </div>
                        </mat-error>

                        <mat-error class="message-erreur"
                            *ngIf="affecterAGamme.hasError('invalidAutocompleteObject') &&  !affecterAGamme.hasError('required') && gammeAppear">
                            <i class="fa-solid fa-triangle-exclamation"></i>  {{'languages.affaire.verifyGamme' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>



            <div class="col-md-6">
                <div *ngIf="!show_loading_produit" class="form-group">

                    <mat-form-field class="full-width" appearance="standard">

                        <mat-label> {{'languages.opportunite.label_product' | translate}}</mat-label>
                        <input type="text" [readonly]="!disabledlistproduit" required matInput
                            [formControl]="affecterAproduit" name="produit" [matAutocomplete]="autoProduit">

                        <mat-autocomplete [displayWith]="displayProduitFn" autoActiveFirstOption
                            #autoProduit="matAutocomplete">
                            <mat-option *ngFor="let option of listProduitFilter | async" [value]="option">
                                {{option.libelle}}
                            </mat-option>
                        </mat-autocomplete>

                        <mat-error
                            *ngIf="affecterAproduit.invalid && (affecterAproduit.dirty || affecterAproduit.touched)"
                            class="message-erreur">
                            <div *ngIf="affecterAproduit.hasError('required') && produitAppear">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                 {{'languages.affaire.obligPoduct' | translate}}
                            </div>
                            <div *ngIf="!produitAppear">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                               {{'languages.affaire.noProductGamme' | translate}}
                            </div>

                        </mat-error>

                        <mat-error class="message-erreur"
                            *ngIf="affecterAproduit.hasError('invalidAutocompleteObject') &&  !affecterAproduit.hasError('required') && produitAppear">
                            <i class="fa-solid fa-triangle-exclamation"></i> {{'languages.affaire.verifyProduct' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <ng-container *ngIf="show_loading_produit">
                    <div>
                        <div class="col-12 text-center">
                            <div class="customWidth">
                                <mat-spinner [diameter]="20"></mat-spinner>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
           

            <div class="col-md-6">
                <div  class="form-group">
                    <mat-form-field class="full-width mt-2" appearance="standard">
                            <mat-label>{{'languages.affaire.fractioPrime' | translate}}</mat-label>
                            <mat-select name="Fractionnement_prime" [formControl]="fractionnment" required matSelect >
                                <mat-option *ngFor="let fractionnement of listFractionnement"
                                [value]="fractionnement.id">{{fractionnement.libelle}}</mat-option>
                            </mat-select>
                    </mat-form-field>
                    <div *ngIf="fractionnment.invalid && (fractionnment.dirty || fractionnment.touched)" class="message-erreur">
                        <div *ngIf="fractionnment.errors.required">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                             {{'languages.affaire.obligFractionnement' | translate}}
                        </div>
                    </div>
                </div>
            </div>

            <!--   <div class="col-md-6">
                                <div  class="form-group" >

                                    <mat-form-field  class="full-width" appearance="standard">

                                      <mat-label>Statut</mat-label>
                                      <input type="text"
                                      required matInput
                                      [formControl]="affecterStatut"
                                       name="Statut" [matAutocomplete]="autoStatut" >
                                      <mat-autocomplete  [displayWith]="displayStatutFn"  autoActiveFirstOption
                                         #autoStatut="matAutocomplete">
                                          <mat-option *ngFor="let option of listStatutFilter | async" [value]="option">
                                              {{option.etat}}
                                          </mat-option>
                                      </mat-autocomplete>

                                      <mat-error
                                      *ngIf="affecterStatut.invalid && (affecterStatut.dirty || affecterStatut.touched)"
                                      class="message-erreur">
                                       <div *ngIf="affecterStatut.hasError('required')&& StatutDepart">
                                          <i class="fa-solid fa-triangle-exclamation"></i>
                                          Statut est obligatoire!
                                        </div>
                                        <div *ngIf="!StatutDepart">
                                            <i class="fa-solid fa-triangle-exclamation"></i>
                                            Ce ligne de produit n'a pas de statut !
                                          </div>
                                    </mat-error>

                                    </mat-form-field>
                                  </div>
                                  <ng-container *ngIf="show_loading_statut">
                                    <div>
                                        <div class="col-12 text-center">
                                            <div class="customWidth">
                                                <mat-spinner [diameter]="20"></mat-spinner>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div> -->
                            <div class="col-md-6">
                                <mat-form-field appearance="fill" class="w-100" required>
                                    <mat-label>{{'languages.affaire.dateDeffet' | translate}}</mat-label>
                                    <input matInput [matDatepicker]="effet" [(ngModel)]="datedeffet" 
                                           #date="ngModel" readonly (click)="effet.open()" name="date" required>
                                    <mat-datepicker-toggle matSuffix [for]="effet"></mat-datepicker-toggle>
                                    <mat-datepicker #effet></mat-datepicker>
                                    <mat-error *ngIf="date.invalid && (date.dirty || date.touched)">
                                        <div *ngIf="date.errors?.required">
                                            <i class="fa-solid fa-triangle-exclamation"></i>
                                            {{'languages.affaire.effectDateEffet' | translate}}
                                        </div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            

            <div class="col-md-6">
                <mat-form-field appearance="fill" class="w-100" required>
                    <mat-label>{{'languages.affaire.subscriptionDatee' | translate}}</mat-label>
                    <input matInput [matDatepicker]="souscription" [(ngModel)]="datedsous"
                           #datesous="ngModel" readonly
                           (click)="souscription.open()" name="datesous" required>
                    <mat-datepicker-toggle matSuffix [for]="souscription"></mat-datepicker-toggle>
                    <mat-datepicker #souscription></mat-datepicker>
                    <mat-error *ngIf="datesous.invalid && (datesous.dirty || datesous.touched)">
                        <div *ngIf="datesous.errors?.required">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                            {{'languages.affaire.obligDateSouscription' | translate}}
                        </div>
                    </mat-error>
                </mat-form-field>
            </div>
            
            

            <div class="col-md-6 col-md-6 d-flex justify content-center align-items-center">
                
                <label class="mx-2 mt-4">{{'languages.gamme.renewable' | translate}}</label>
                <label class="switch mt-4">
                    <input type="checkbox" [disabled]="disabledlistRenewable" name="Renewable" [checked]="gammeRenewable == '1'"
                        (change)="isRenewable($event)">
                    <span class="slider round"></span>
                </label>
                
            
        </div>
       
        <div class="col-md-6" *ngIf="gammeRenewable == '1'">
            <div class="form-group">
                <mat-form-field class="full-width mt-2" appearance="standard">
                    <mat-label>{{'languages.affaire.RenewNoticeSending' | translate}}</mat-label>
                    <mat-select required name="RenewNoticeSending" [formControl]="SendingMode">
                        <mat-option *ngFor="let SendingMode of listRenewNoticeSendingMode"
                                    [value]="SendingMode.id">{{SendingMode.type}}</mat-option>
                    </mat-select>
                    <div *ngIf="SendingMode.invalid && (SendingMode.dirty || SendingMode.touched) && gammeRenewable=='1'"
                         class="message-erreur">
                        <div *ngIf="SendingMode.errors.required">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                            {{'languages.affaire.obligSendingMode' | translate}}
                        </div>
                    </div>
                </mat-form-field> 
            </div>
        </div>
        
        <div class="col-md-6" >
            <div class="form-group">
                <mat-form-field class="full-width mt-2" appearance="standard">
                    <mat-label>{{ 'languages.affaire.terme' | translate }}</mat-label>
                    <mat-select name="terme" [formControl]="terme" >
                        <mat-option *ngFor="let value of [1, 3, 6, 12]" [value]="value">{{ value }}</mat-option>
                    </mat-select>
                    <div *ngIf="terme.invalid && (terme.dirty || terme.touched)" class="message-erreur">
                        <div *ngIf="terme.errors.required">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                            {{ 'languages.affaire.obligterme' | translate }}
                        </div>
                    </div>
                </mat-form-field>
            </div>
        </div>
        

            <div class="col-12">
                <h3 class="mt-2" *ngIf="selectedStatuss"> {{'languages.opportunite.details.selectedStatut' | translate}}: <span
                        style="font-size: 20px; margin-left: 15px">
                        <b>{{selectedStatuss.etat}}</b></span>
                </h3>

                <p *ngIf="tree.length >0"> {{'languages.affaire.selectStatutDepart' | translate}}:</p>

                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                        <li class="mat-tree-node">
                            <!-- <button mat-icon-button></button>
                            <mat-checkbox color="primary" class="checklist-leaf-node" [checked]="selectedStatuss.id==node.id" (change)="todoLeafItemSelectionToggle(node)">
                                {{node.item}}</mat-checkbox> -->

                            <mat-radio-button name="libelle_cat_parent" [checked]="node?.id == selectedStatuss?.id"
                                (change)="todoLeafItemSelectionToggle(node)">{{node?.item}}</mat-radio-button>
                        </li>
                    </mat-tree-node>
                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                        <li>
                            <div class="mat-tree-node">
                                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                    </mat-icon>
                                </button> {{node.item}}
                            </div>
                            <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                                <ng-container matTreeNodeOutlet></ng-container>
                            </ul>
                        </li>
                    </mat-nested-tree-node>
                </mat-tree>


            </div>
        </div>
        <div class="row  d-flex justify-content-center aligh-items-center mt-2">
            <button type="submit" class="btn-dt-save-popup mr-2" (click)="SaveAffaire()">
<i class="fa-solid fa-circle-check fa-lg mr-1"></i>
                {{'languages.buttons.enregistrer' | translate}}
            </button>
            <button type="button" class="btn-dt-fermer  ml-2" #closebuttonAffaire aria-label="Close"
            (click)="activeModal.dismiss('Cross click')">
            <i class="fa-solid fa-circle-xmark fa-icon-style fa-lg mr-1"></i>
            {{'languages.buttons.annuler' | translate}}

        </button> 
              
        
              
        
           
        </div>

    </div>
</div>
